import { trans } from "i18n";
import { sortByKey } from "lib/modules/util";

export function bookingUrl(booking) {
	const sp = new URLSearchParams();

	sp.set("method", booking.method);

	if (booking.method === "office")
		sp.set("branch_id", booking.branch_id);

	sp.set("lang_id", booking.lang_id);
	sp.set("user_id", booking.puser_id);

	return `booking/${booking.srv_id}?${sp.toString()}`;
}

export function sortParticipants(parts) {
	sortByKey(parts, "role", "fname", "lname");
}

export function roleName(role) {
	switch (role) {

	case "host": return trans.gettext("Host");
	case "client": return trans.gettext("Client");
	case "guest": return trans.gettext("Guest");
	default: return role;
	}
}

export function methodName(met) {
	switch (met) {

	case "office": return trans.gettext("In-person");
	case "phone": return trans.gettext("Phone");
	case "video": return trans.gettext("Video");
	default: return met;
	}
}

export function logEventTitle(event) {
	switch (event) {

	case "create": return trans.gettext("The booking was created");
	case "update": return trans.gettext("The booking was updated");
	case "cancel": return trans.gettext("The booking was canceled");
	case "refund": return trans.gettext("The booking was refunded");
	case "join": return trans.gettext("User joined video session");
	case "leave": return trans.gettext("User left video session");
	default: return event;
	}
}

export function methodIcon(method) {
	switch (method) {

	case "video": return "fa-video";
	case "office": return "fa-building";
	case "phone": return "fa-phone";
	default: return "fa-question";
	}
}

export function canReschedule(booking, now, host) {
	if (booking.srv_id === null)
		return false;

	if (host)
		return now < booking.start + booking.duration;

	return booking.resched_hrs > 0 && now + booking.resched_hrs * 3600 < booking.start;
}
